// extracted by mini-css-extract-plugin
export default {"icone":"chapters_icone__r6dVj","navSong":"chapters_navSong__baZYB"};